import { render, staticRenderFns } from "./RoleScreen.vue?vue&type=template&id=64025e19"
import script from "./RoleScreen.vue?vue&type=script&lang=js"
export * from "./RoleScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports